import { z } from 'zod';
import { PROJECT_SEARCH_SCOPES, type ProjectSearchCounts } from '@projectSearch/searchScope';

const count = z.number().int().nonnegative();

/** Ответ GET /projects/search-counts?q=… — числа на вкладках поиска; области — из общего модуля с сервером. */
export const projectSearchCountsSchema = z.object(
  Object.fromEntries(PROJECT_SEARCH_SCOPES.map((scope) => [scope, count])) as Record<keyof ProjectSearchCounts, typeof count>
);

export type { ProjectSearchCounts };
